import { TrustAPI } from "@/shared/modules/trust-api";
import { ComplianceForm, PracticeAtcs } from "@/shared/modules/typescript-trustapi-client/models";
import store from "@/trust-atcs-app/store";
import { EventEmitter } from "events";
import { Inject, Options, Prop, Vue } from "vue-property-decorator";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { AppInsights } from "@/trust-atcs-app/appInsights";

@Options({
  components: {
    LoadingIndicator
  }
})
export default class AppointCoordinator extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: false })
  private modalOpened!: boolean;

  @Prop({ default: null })
  private practice!: ComplianceForm;

  private submitting = false;

  private ai = new AppInsights;

  mounted() {
    if (!this.modalOpened) {
      document.body.classList.add('modal-open');
    }
  }

  beforeUnmount() {
    if (!this.modalOpened) {
      document.body.classList.remove('modal-open');
    }
  }

  private cancel(): void {
    if (!this.submitting) {
      this.$emit('close');
    }
  }

  private async appoint(): Promise<void> {
    try {
      this.submitting = true;
      const resp: any = await this.apiService.PracticeAtcsApi?.apiV2AtcsPracticeAssignSelfTrustCoordinatorPracticeCoreIdPost(
        this.practice?.practice?.practiceCoreId
      );
      this.eventCtrl.emit('show-snackbar', 'success', 'Assigned Self as Trust Coordinator successfully');
      this.eventCtrl.emit('loadCardData');
      this.$emit('close');

    } catch (e) {
      console.log(e);
      this.ai.trackException('Unable to assign Self as Trust Coordinator: ' + e);
      this.eventCtrl.emit('show-snackbar', 'error', 'Unable to assign Self as Trust Coordinator');
    } finally {
      this.submitting = false;
    }
    
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }
}

